<template>
  <div ref="orderHome" class="orderHome flex flex-auto flex-column padd30 mar30_b" :class="{ homeActive: isOpenType == 0 || isOpenType == 1 }" v-if="loadTrue">
    <div class="flex-auto bor-de bor_radius_10" :class="{ mar30_b: isOpenType != 0 }" v-if="isOpenType == 0">
      <div class="flex header">
        <div class="flex-auto title">设置助手</div>
      </div>
      <div class="padd30">
        <ul class="ul-cls flex general-store">
          <li class="flex items-center justify-center flex-column" :class="{ 'store-active': switchType == 'JC' }" @click="toAssistantSwitch('JC')">
            <img src="./images/jichu.png" alt="" />
            <div>基础设置</div>
          </li>
          <li class="flex items-center justify-center flex-column" :class="{ 'store-active': switchType == 'SP' }" @click="toAssistantSwitch('SP')">
            <img src="./images/huopin.png" alt="" />
            <div>商品管理</div>
          </li>
          <li class="flex items-center justify-center flex-column" :class="{ 'store-active': switchType == 'KH' }" @click="toAssistantSwitch('KH')">
            <img src="./images/kehu.png" alt="" />
            <div>客户管理</div>
          </li>
          <li class="flex items-center justify-center flex-column" :class="{ 'store-active': switchType == 'XS' }" @click="toAssistantSwitch('XS')">
            <img src="./images/xiaoshou.png" alt="" />
            <div>销售管理</div>
          </li>
          <li
            class="flex items-center justify-center flex-column"
            :class="{ 'store-active': switchType == 'YX' }"
            @click="toAssistantSwitch('YX')"
            v-if="shopDtlEntity.shopSort == 'MICRO_STORE'"
          >
            <img src="./images/yingxiao.png" alt="" />
            <div>营销管理</div>
          </li>
        </ul>
        <ul class="mar20-t ul-cls general-step flex" v-if="switchType == 'JC'">
          <li>
            <div class="f16 fb pad10-b">店铺信息</div>
            <div class="gray9 mar10-b lin25 h50">企业简介与视频等基础信息设置</div>
            <div class="blue pointer" @click="toShopIndex">立即查看 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">支付设置</div>
            <div class="gray9 mar10-b lin25 h50">启用微信、支付宝、银行卡等支付</div>
            <div class="blue pointer" @click="toShopFunction">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">配送设置</div>
            <div class="gray9 mar10-b lin25 h50">设置配送模板、自提地址</div>
            <div class="blue pointer" @click="toOtherAddr">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">运费设置</div>
            <div class="gray9 mar10-b lin25 h50">可设置运费模板，用于商品的运费配置</div>
            <div class="blue pointer" @click="toFeight">立即设置 ></div>
          </li>
        </ul>
        <ul class="mar20-t ul-cls general-step flex" v-if="switchType == 'SP'">
          <li>
            <div class="f16 fb pad10-b">商品设置</div>
            <div class="gray9 mar10-b lin25 h50">商品的新增、编辑、上下架等管理</div>
            <div class="blue pointer" @click="toGoodsList">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">分类管理</div>
            <div class="gray9 mar10-b lin25 h50">设置商品分类及分类图标等信息</div>
            <div class="blue pointer" @click="toShopClassify">立即设置 ></div>
          </li>
        </ul>
        <ul class="mar20-t ul-cls general-step flex" v-if="switchType == 'KH'">
          <li>
            <div class="f16 fb pad10-b">客户列表</div>
            <div class="gray9 mar10-b lin25 h50">店铺老客户展示、新客户引入、客户所属分组等设置</div>
            <div class="blue pointer" @click="toCustomerNew">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">客户分组</div>
            <div class="gray9 mar10-b lin25 h50">设置客户的分组信息，用于客户分层管理</div>
            <div class="blue pointer" @click="toCustomerGroup">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">价格方案</div>
            <div class="gray9 mar10-b lin25 h50">针对不同客户设置不同的商品价格设置</div>
            <div class="blue pointer" @click="toPriceListPage">立即设置 ></div>
          </li>
        </ul>
        <ul class="mar20-t ul-cls general-step flex" v-if="switchType == 'XS'">
          <li>
            <div class="f16 fb pad10-b">销售订单</div>
            <div class="gray9 mar10-b lin25 h50">查看销售订单明细、详情，对订单进行发货、售后的处理</div>
            <div class="blue pointer" @click="toOrderList(0)">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">销售汇总</div>
            <div class="gray9 mar10-b lin25 h50">按商品、客户两个维度汇总展示销售数据</div>
            <div class="blue pointer" @click="toSellCollect">立即查看 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">对账单</div>
            <div class="gray9 mar10-b lin25 h50">查看订单商品的收款对账信息</div>
            <div class="blue pointer" @click="toBillPage">立即查看 ></div>
          </li>
        </ul>
        <ul class="mar20-t ul-cls general-step flex" v-if="switchType == 'YX'">
          <li>
            <div class="f16 fb pad10-b">广告设置</div>
            <div class="gray9 mar10-b lin25 h50">设置首页的轮播广告和商品推荐</div>
            <div class="blue pointer" @click="toIndexCarouselFiguer">立即设置 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">优惠券管理</div>
            <div class="gray9 mar10-b lin25 h50">添加设置优惠券活动</div>
            <div class="blue pointer" @click="toShopCoupon">立即创建 ></div>
          </li>
          <li>
            <div class="f16 fb pad10-b">促销管理</div>
            <div class="gray9 mar10-b lin25 h50">店铺设置促销活动（包括直降、折扣、买赠等活动）,吸引顾客进店购买</div>
            <div class="blue pointer" @click="toPromotionPage">立即创建 ></div>
          </li>
        </ul>
      </div>
    </div>
    <!--<div class="orderHome_left">

      <div class="box_shadow padd30 bor_radius_10 mar30_b todo_list">
        <p class="gray_3 mar30_b f16">待办事项</p>
        <ul class="flex_space_between t_center">
          <li @click="toOrderList(1)">
            <div class="todo_list_item">
              <img src="./images/todo_list_item1.png" alt="" />
              <div class="todo_list_token">{{ orderStatus_1 }}</div>
            </div>
            <p class="gray_3">待支付订单</p>
          </li>
          <li @click="toOrderList(2)">
            <div class="todo_list_item">
              <img src="./images/todo_list_item2.png" alt="" />
              <div class="todo_list_token">{{ orderStatus_2 }}</div>
            </div>
            <p class="gray_3">待发货订单</p>
          </li>
          <li @click="toOrderList(3)">
            <div class="todo_list_item">
              <img src="./images/todo_list_item3.png" alt="" />
              <div class="todo_list_token">{{ orderStatus_3 }}</div>
            </div>
            <p class="gray_3">待收货订单</p>
          </li>
          <li @click="toOrderList(-1)">
            <div class="todo_list_item">
              <img src="./images/todo_list_item4.png" alt="" />
              <div class="todo_list_token">{{ orderStatus_4 }}</div>
            </div>
            <p class="gray_3">售后订单</p>
          </li>
          &lt;!&ndash;<li>&ndash;&gt;
          &lt;!&ndash;<div class="todo_list_item">&ndash;&gt;
          &lt;!&ndash;<img src="./images/todo_list_item5.png" alt="">&ndash;&gt;
          &lt;!&ndash;<div class="todo_list_token">1000</div>&ndash;&gt;
          &lt;!&ndash;</div>&ndash;&gt;
          &lt;!&ndash;<p class="gray_3 f16">库存预警</p>&ndash;&gt;
          &lt;!&ndash;</li>&ndash;&gt;
        </ul>
      </div>
      <div class="box_shadow padd30 bor_radius_10 mar30_b operations_today">
        <p class="clear gray_3 mar40_b f16">今日概况：今日数据更新时间：{{ currentTime }}</p>
        <ul class="flex_space_between t_center mar_auto">
          <li>
            <p class="f48 gray_3 mar20_b">{{ todayOrderNum }}</p>
            <p class="f16 gray_3">今日订单</p>
          </li>
          <li>
            <p class="f48 gray_3 mar20_b">{{ sumNumByBoId }}</p>
            <p class="f16 gray_3">下单客户</p>
          </li>
          <li>
            <p class="f48 gray_3 mar20_b c_nx_blue">{{ todayOrderMoney }}</p>
            <p class="f16 gray_3">今日订单额</p>
          </li>
          <li>
            <p class="f48 gray_3 mar20_b">{{ moneyOnLineDay }}</p>
            <p class="f16 gray_3">今日收入</p>
          </li>
        </ul>
      </div>
      <div class="box_shadow padd30 bor_radius_10 mar30_b operations_summary">
        <p class="clear gray_3 mar20_b f16">经营概况</p>
        <div class="flex_space_between mar20_b">
          <ul>
            <li class="bor_radius_5_l" :class="{ summary_active: isOrder == '1' }" @click="getOrder('1')">销售金额</li>
            <li class="bor_radius_5_r" :class="{ summary_active: isOrder == '2' }" @click="getOrder('2')">订单数量</li>
          </ul>
          <ul>
            <li class="bor_radius_5_l" :class="{ summary_active: isCheckDays == '8' }" @click="getOrderLoad('8')">
              近一周
            </li>
            <li :class="{ summary_active: isCheckDays == '31' }" @click="getOrderLoad('31')">近一月</li>
            <li :class="{ summary_active: isCheckDays == '181' }" @click="getOrderLoad('181')">近半年</li>
            <li class="bor_radius_5_r" :class="{ summary_active: isCheckDays == '366' }" @click="getOrderLoad('366')">
              近一年
            </li>
          </ul>
        </div>
        <div id="chartLineBox" style="width: 100%; height: 400px" v-loading="loading"></div>
      </div>
      <div class="box_shadow padd30 bor_radius_10 mar30_b sales_rank">
        <p class="clear gray_3 mar30_b f16">单品销量TOP10</p>
        <div>
          <el-table :data="tableData" stripe class="t_center">
            <el-table-column label="排名" width="130">
              <template #default="scope">
                <span v-if="scope.$index === 0" class="white sales_rank_item sales_rank1">{{ scope.row.rank }}</span>
                <span v-else-if="scope.$index === 1" class="white sales_rank_item sales_rank2">{{
                  scope.row.rank
                }}</span>
                <span v-else-if="scope.$index === 2" class="white sales_rank_item sales_rank3">{{
                  scope.row.rank
                }}</span>
                <span v-else class="sales_rank_item">{{ scope.row.rank }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="货品名称" width="445"> </el-table-column>
            <el-table-column prop="size" label="规格" width="445"> </el-table-column>
            <el-table-column prop="sale" label="销量"> </el-table-column>
          </el-table>
        </div>
      </div>
    </div>-->
    <template v-if="isOpenType == 1">
      <div
        class="flex flex-auto flex-column bor-de bor_radius_10 shop_info h365"
        :class="{ mar30_b: isOpenType != 1 }"
        v-if="shopDtlEntity.shopSort == 'ORDER_GOODS'"
      >
        <div class="flex header">
          <div class="flex-auto title">小程序</div>
        </div>
        <div class="flex flex-auto flex-column items-center justify-center padd30">
          <p class="gray_3 f18 mar20-b t_center">{{ shopInfo.name }}</p>
          <div class="flex flex-column flex_ver_center mar10-b">
            <span class="gray_6 f14 flex_1 lin_20 mar10-b">扫码进入小程序，推荐给您的客户，您的客户将在小程序上进行采购</span>
            <img class="wx_code" src="https://filesouthcdn.nxin.com/nxsc_173019846074307706381249643669.JPEG" alt="" />
          </div>
          <p class="clear gray_6 f14 lin_20">
            <span class="float-left">主营：</span>
            <span class="float-left ellipsis_two w290">{{ businesScope }}</span>
          </p>
        </div>
        <!--<el-button type="primary" round>升级为网店</el-button>-->
      </div>
      <div class="flex flex-auto flex-column bor-de bor_radius_10 shop_info h365" :class="{ mar30_b: isOpenType != 1 }" v-else>
        <div class="flex header">
          <div class="flex-auto title">小程序</div>
        </div>
        <div class="flex flex-auto flex-column items-center justify-center padd30">
          <p class="gray_3 f18 mar30_b t_center">{{ shopInfo.name }}</p>
          <div class="flex flex-column items-center justify-center mar10_b" v-if="appletInfo && appletInfo.appId != ''">
            <img class="wx_code" :src="authUrl" alt="" />
            <div class="text-center mar10-t">
              <p class="gray_6 f14">扫码进入小程序，推荐给您的客户</p>
              <p class="gray_6 f14">您的客户将在小程序上进行采购</p>
            </div>
          </div>
          <div v-else>
            <div class="flex flex_ver_center mar15_b">
              <span class="gray_6 f14 flex_1 lin_25 t_center">开通企业专属、独立品牌微信小程序</span>
            </div>
            <el-button type="primary" size="medium" @click="toWeiXinPage"> 立即开通 </el-button>
          </div>
        </div>
      </div>
      <div class="flex-auto mar30-t bor-de bor_radius_10 shop_announcement h275">
        <!-- <p class="shop_announcement_head"></p> -->
        <div class="flex header">
          <div class="flex-auto title">平台公告</div>
        </div>
        <ul class="clear padd30" v-if="notice">
          <template v-for="(cont, index) in notice">
            <li class="ellipsis" @click="toNotice(cont.url)" :key="index" v-if="index <= 4">{{ index + 1 }}. {{ cont.title }}</li>
          </template>
        </ul>
      </div>
      <!--<div class="box_shadow padd30 bor_radius_10 w400 mar30_b shop_service">
        <p class="shop_service_head">平台公告</p>
        <ul class="clear">
          <li>客服电话：400-660-5555</li>
          <li>客服邮箱：service4006@300.cn</li>
          <li>QQ群：298998897</li>
        </ul>
      </div>
      <div class="box_shadow padd30 bor_radius_10 w400 mar30_b shop_more">
        <p>更多功能敬请期待</p>
      </div>-->
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import "./index.scss";
</style>
<style>
.el-message {
  min-width: 300px;
}
.shopInfoMag .el-message-box__headerbtn:focus .el-message-box__close,
.shopInfoMag .el-message-box__headerbtn:hover .el-message-box__close {
  color: #909399;
}
.shopInfoMag .el-button--default:hover,
.shopInfoMag.el-button--default:focus {
  background: #ffffff;
  border: 1px solid #dcdfe6;
  color: #606266;
}
.shopInfoMag .el-button--primary,
.shopInfoMag .el-button--primary:hover,
.shopInfoMag.el-button--primary:focus {
  background-color: #0095f1;
  border-color: #0095f1;
  color: #fff;
}
</style>
<script>
import { mapState } from "vuex";
import echarts from "echarts";
// import RealtimeOverview from '@/components/RealtimeOverview';

export default {
  components: {
    // RealtimeOverview,
  },
  data() {
    return {
      loadTrue: false,
      tableData: [],
      shopInfo: {},
      businesScope: "",
      orderStatus_1: "0",
      orderStatus_2: "0",
      orderStatus_3: "0",
      orderStatus_4: "0",
      todayOrderNum: "0",
      sumNumByBoId: "0",
      todayOrderMoney: "0.00",
      moneyOnLineDay: "0.00",
      goodList: [],
      currentTime: "",
      notice: [],
      charts: "",
      isOrder: "1",
      isCheckDays: "8",
      loading: true,
      dayNumList: [],
      timeList: [],
      sumMoney: [],
      switchType: "JC",
      shopDtlEntity: {},
      appletInfo: null,
      authUrl: "",
      isOpenType: 0,
    };
  },
  computed: mapState({
    showTitle: (state) => state.app.showTitle,
  }),
  created() {
    this.isOpenType = this.$route.params.isOpenType || 0;
    const { cardId } = this.$route.query;
    const orderHeight = this.isOpenType === "0" ? 365 : 670;
    console.log("onresizeCreated", cardId, orderHeight);
    window.parent.postMessage({ cardId, height: orderHeight }, "*");
    this.$store.commit("app/setShowTitle", false);
    this.$store.dispatch("orderHome/index/getQuerySingleShop").then((res) => {
      if (res.data) {
        this.loadTrue = true;
        this.shopInfo = res.data;
        this.$store.dispatch("shop/shop/queryShopDtlByBoId").then((data) => {
          if (data.data) {
            this.shopDtlEntity = data.data.shopDtlEntity;
          }
        });
        this.$store.dispatch("applet/applet/getShopAppletInfo", { isRelease: 1 }).then((applet) => {
          if (applet) {
            this.appletInfo = applet;
            if (this.appletInfo.appId !== "") {
              this.$store.dispatch("applet/applet/getQrcodeUrl", { ucAppId: this.appletInfo.appId }).then((authUrl) => {
                if (authUrl && authUrl.data) {
                  this.authUrl = authUrl.data;
                }
              });
            }
          }
        });
        this.businesScope = this.shopInfo.businesScope ? this.shopInfo.businesScope.replace(",", " | ") : ""; //eslint-disable-line
        //this.loadOrderDetail("3", "8");
        // 订单各项状态
        /* this.$store
          .dispatch("orderHome/index/getQueryOrderNum", {
            shop_id: this.shopInfo.shopIds
          })
          .then(resA => {
            if (resA.data) {
              this.orderStatus_1 = resA.data.orderStatus1;
              this.orderStatus_2 = resA.data.orderStatus2;
              this.orderStatus_3 = resA.data.orderStatus3;
              this.orderStatus_4 = resA.data.refundStatusCount;
            }
          });*/
        // 销售排行榜
        /*this.$store
          .dispatch("orderHome/index/getQueryGoodsRankingList", { shopId: this.shopInfo.shopIds })
          .then(data1 => {
            if (data1) {
              this.goodList = data1 || [];
              this.goodList.forEach((e, index) => {
                const goodsData = {
                  rank: "",
                  name: "",
                  size: "",
                  sale: ""
                };
                goodsData.rank = index + 1;
                goodsData.name = e.name;
                goodsData.size = e.spec;
                goodsData.sale = e.goodsSelled;
                this.tableData.push(goodsData);
              });
            }
          });
        const thisDate = new Date();
        // 获取当前时间，格式为 2018-9-10 20:08
        this.currentTime = `${thisDate.getFullYear()}-${thisDate.getMonth() +
          1}-${thisDate.getDate()} ${thisDate.getHours()}:${thisDate.getMinutes()}`;*/
        // 通知公告
        this.$store
          .dispatch("orderHome/index/getQueryNotice", {
            platformType: "SC",
          })
          .then((data2) => {
            if (data2) {
              this.notice = data2 || [];
            }
          });
      }
    });
  },

  mounted() {
    // orderHome
    const { cardId } = this.$route.query;
    //  this.isOpenType
    // const that = this;
    window.onresize = () => {
      // const orderHeight = this.$refs.orderHome.offsetHeight;
      const orderHeight = this.isOpenType === "0" ? 365 : 670;
      console.log("onresize", cardId, orderHeight);
      window.parent.postMessage({ cardId, height: orderHeight }, "*");
      // that.charts.resize();
    };
  },
  methods: {
    loadOrderDetail(item, selDays) {
      this.timeList = [];
      this.sumMoney = [];
      // 订单量
      if (item === "3" || item === "1") {
        this.$store
          .dispatch("orderHome/index/getQueryPlaceOrderNum", {
            shop_id: this.shopInfo.shopIds,
            days: selDays,
          })
          .then((resB) => {
            if (resB.data) {
              this.todayOrderNum = resB.data.today;
              this.sumNumByBoId = resB.data.sumNumByBoId;
              if (item !== "3") {
                this.dayNumList = resB.data.dayNumList;
                this.dayNumList.forEach((e) => {
                  this.timeList.push(e.time);
                  this.sumMoney.push(e.num);
                });
                this.$nextTick(() => {
                  this.drawLine("chartLineBox");
                });
              }
            }
          });
      }
      // 订单金额
      if (item === "3" || item === "2") {
        this.$store
          .dispatch("orderHome/index/getQueryOrderMoney", {
            shop_id: this.shopInfo.shopIds,
            days: selDays,
          })
          .then((resC) => {
            if (resC.data) {
              this.todayOrderMoney = resC.data.today;
              this.moneyOnLineDay = resC.data.moneyOnLineDay;
              this.dayNumList = resC.data.dayNumList;
              this.dayNumList.forEach((e) => {
                this.timeList.push(e.time);
                this.sumMoney.push(e.sumMoney);
              });
              this.$nextTick(() => {
                this.drawLine("chartLineBox");
              });
            }
          });
      }
    },
    // 助手切换
    toAssistantSwitch(type) {
      this.switchType = type;
    },
    getOrder(type) {
      this.isOrder = type;
      if (type === 1) {
        this.loadOrderDetail("2", this.isCheckDays);
      } else {
        this.loadOrderDetail("1", this.isCheckDays);
      }
      this.loading = false;
    },
    getOrderLoad(days) {
      this.isCheckDays = days;
      if (this.isOrder === "1") {
        this.loadOrderDetail("2", days);
      } else {
        this.loadOrderDetail("1", this.isCheckDays);
      }
      this.loading = false;
    },
    drawLine(id) {
      // 配置文件
      // https://echarts.apache.org/examples/zh/editor.html?c=line-simple
      this.charts = echarts.init(document.getElementById(id));
      this.charts.setOption({
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["近七日收益"],
        },
        color: ["#2e86ff"],
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.timeList,
        },
        yAxis: {
          type: "value",
          minInterval: 1,
        },
        series: [
          {
            name: "",
            type: "line",
            stack: "总量",
            data: this.sumMoney,
          },
        ],
      });
    },
    toNotice(url) {
      window.parent.postMessage({ fn: "open", data: { url: `${url}?colCode=sc_code`, title: "通知公告", target: 0 } }, "*");
    },
    toFeight() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/freight/toFreightListEtp.do?appid=1&isDH=1`, title: "运费设置", target: 0 } },
        "*"
      );
    },
    toCategoryAdd() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/toCategoryAdd?appid=1`, title: "添加货品", target: 0 } }, "*");
    },
    toCustomerAdd() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/customer/toAddCustomerNew?appid=1`, title: "添加客户", target: 0 } },
        "*"
      );
    },
    toPriceListPage() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/priceScheme/toPriceListPage.do?appid=1`, title: "价格方案", target: 0 } },
        "*"
      );
    },
    toOtherAddr() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/toOtherAddr.do?appid=1`, title: "配送管理", target: 0 } }, "*");
    },
    toShopFunction() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/toShopFunction?appid=1`, title: "系统设置", target: 0 } }, "*");
    },
    toGoodsList() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/toGoodsMJ.do?appid=1`, title: "货品管理", target: 0 } }, "*");
    },
    toOrderList(id) {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/order/manage/orderList.do?appid=1&orderStatus=${id}`, title: "订单管理", target: 0 } },
        "*"
      );
    },
    toCustomerNew() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/customer/toCustomerNew.do?appid=1`, title: "客户列表", target: 0 } },
        "*"
      );
    },
    toCustomerGroup() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/customer/toCustomerGroup.do?appid=1`, title: "客户分组", target: 0 } },
        "*"
      );
    },
    toBindingCard() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_JR}v/accountAsset/balance/entBindCard?`, title: "绑卡管理", target: 0 } },
        "*"
      );
    },
    toShopIndex() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/queryShopMJ.do?appid=1`, title: "店铺信息", target: 0 } }, "*");
    },
    toAssign() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/member/getAssign.do?appid=2104091010470000101`, title: "员工引入", target: 0 } },
        "*"
      );
    },
    toShopClassify() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}classify/toShopClassify.do?appid=1`, title: "商品分类管理", target: 0 } },
        "*"
      );
    },
    toSellCollect() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}v/mj/sellCollect?isShowTitle=1&appid=1`, title: "销售汇总表", target: 0 } },
        "*"
      );
    },
    toBillPage() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/bill/page.do?appid=1`, title: "销售对账单", target: 0 } }, "*");
    },
    toShopSatnav() {
      window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}satnav/toShopSatnav.do?appid=1`, title: "导航设置", target: 0 } }, "*");
    },
    toIndexCarouselFiguer() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}index/toIndexCarouselFiguer.do?appid=1`, title: "首页装修", target: 0 } },
        "*"
      );
    },
    toShopCoupon() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}mj/coupon/toShopCoupon.do?appid=1`, title: "优惠券管理", target: 0 } },
        "*"
      );
    },
    toPromotionPage() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}v/mj/promotion/list?appid=1&isShowTitle=1`, title: "促销管理", target: 0 } },
        "*"
      );
    },
    toWeiXinPage() {
      if (this.shopDtlEntity.shopSort === "PUBLIC") {
        // const h = this.$createElement;
        this.$message({
          dangerouslyUseHTMLString: true,
          message: "<div class='lin_20'>若需开通服务，请联系客服人员！</div><div class='lin_20'>客服电话:18600502193(同微信号)</div>",
          type: "warning",
        });
        // this.$msgbox({
        //   title: "消息",
        //   message: h("p", null, [
        //     h("span", null, "若需开通服务，请联系客服人员！"),
        //     h("span", null, "客服电话:18600502193(同微信号)"),
        //   ]),
        //   showCancelButton: false,
        //   confirmButtonText: "确定",
        //   customClass: "shopInfoMag",
        //   beforeClose: (action, instance, done) => {
        //     if (action === "confirm") {
        //       console.log(action);
        //     } else {
        //       done();
        //     }
        //   },
        // });
      } else {
        window.parent.postMessage({ fn: "open", data: { url: `${process.env.VUE_APP_APP}v/miniProgram`, title: "微信小程序管理", target: 0 } }, "*");
      }
    },
  },
};
</script>
